export const Spacer = ({ height, width }) => (
    <div
        style={{
            height: height ? `${height}px` : 'auto',
            width: width ? `${width}px` : 'auto',
        }}
    />
);
